import { Directive } from '@angular/core';
import { GoogleMapsAPIWrapper } from 'angular2-google-maps/core';

 declare var gmaps: any;
 declare var google: any;

@Directive({
  selector: 'custom-directive'
})
export class CustomMapDirective {
  constructor (private gmapsApi: GoogleMapsAPIWrapper) {

  }
}



// WEBPACK FOOTER //
// ./src/app/arcgislink.ts